export default "__VITE_ASSET__0dd5e92e__"